import { render, staticRenderFns } from "./updaterefill.vue?vue&type=template&id=5bef665a&"
import script from "./updaterefill.vue?vue&type=script&lang=js&"
export * from "./updaterefill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports